import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Building2, Navigation } from "lucide-react";

const offices = [
  {
    type: "Head Office",
    gradient: "from-emerald-400 to-teal-600",
    bgLight: "bg-emerald-50",
    borderColor: "border-emerald-100",
    iconColor: "text-emerald-600",
    address: "AIRAA Head Office, Mandakini, Jangid Complex Rd, Silver Park, Mira Road East, Mumbai, Mira Bhayandar, Maharashtra 401107",
    phone: "+91 77383 55865",
    tel: "+917738355865",
  },
  {
    type: "Branch Office",
    gradient: "from-violet-400 to-purple-600",
    bgLight: "bg-violet-50",
    borderColor: "border-violet-100",
    iconColor: "text-violet-600",
    address: "AIRAA Branch Office, Office No. 14A, Options Primo, 21st Rd, near Passport Office, Shree Krishna Nagar, Marol MIDC Industry Estate, Andheri East, Mumbai, Maharashtra 400093",
    phone: "+91 77383 55865",
    tel: "+917738355865",
  },
];

const MapSection = () => {
  return (
    <section className="py-8">
      {/* Section header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-10"
      >
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-600 mb-3">Find Us</span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-blue-950 mb-3">
          Our <span className="text-emerald-500">Locations</span>
        </h2>
        <p className="text-slate-500 text-sm max-w-lg mx-auto">
          Visit us at our offices or connect with us directly — we're here to help.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {offices.map((office, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.12, duration: 0.5 }}
            className="relative bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden shimmer-card"
          >
            {/* Gradient top bar */}
            <div className={`h-1 bg-gradient-to-r ${office.gradient}`} />

            {/* Office type badge */}
            <div className="px-6 pt-5 pb-4 flex items-center gap-3">
              <div className={`w-10 h-10 rounded-xl ${office.bgLight} flex items-center justify-center shrink-0`}>
                <Building2 size={18} className={office.iconColor} />
              </div>
              <div>
                <p className={`text-xs font-bold uppercase tracking-widest bg-gradient-to-r ${office.gradient} bg-clip-text text-transparent`}>
                  {office.type}
                </p>
                <p className="text-xs text-slate-400 font-medium">Mumbai, Maharashtra</p>
              </div>
            </div>

            {/* Info */}
            <div className="px-6 space-y-3 py-2">

              {/* Address */}
              <div className="flex items-start gap-3">
                <div className={`w-7 h-7 rounded-lg ${office.bgLight} flex items-center justify-center shrink-0 mt-0.5`}>
                  <MapPin size={13} className={office.iconColor} />
                </div>
                <p className="text-xs text-slate-600 leading-relaxed">
                  {office.address}
                </p>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-3">
                <div className={`w-7 h-7 rounded-lg ${office.bgLight} flex items-center justify-center shrink-0 mt-0.5`}>
                  <Phone size={13} className={office.iconColor} />
                </div>
                <a
                  href={`tel:${office.tel}`}
                  className={`text-xs font-semibold ${office.iconColor} hover:underline`}
                >
                  {office.phone}
                </a>
              </div>

            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default MapSection;
